import React, {Fragment} from 'react'
import {Table} from 'antd'
import RefreshButton from '../../../elements/Buttons/RefreshButton'

const columns = [
  {
    title: 'Code',
    dataIndex: 'code',
    render: value => <a href={"#/corporates/accounts"}>{value}</a>,
  },
  {
    title: 'Name',
    dataIndex: 'name',
  },
  {
    title: 'Company',
    dataIndex: 'company.fn',
  },

  {
    title: 'Type',
    dataIndex: 'type',
  },
  {
    title: 'Category',
    dataIndex: 'category',
  },
]

function List(props) {
  const {filtered, fetch, fetching} = props
  return (
    <Table
      title={() => (
        <Fragment>
          <span>Charts of Accounts</span>
          <RefreshButton onClick={fetch} />
        </Fragment>
      )}
      defaultExpandAllRows={true}
      rowKey={'rand_key'}
      loading={fetching}
      columns={columns}
      dataSource={filtered}
    />
  )
}

List.propTypes = {}
List.defaultProps = {}

export default List
